import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  CalendarGray as CalendarGrayIcon,
  HomeGray as HomeGrayIcon,
  IconPropertyOutline,
  ArrowRight as ArrowRightIcon,
} from '~components/svgs';
import { formatDay, dayFormatType, calcTenancyLength } from 'common/helpers/day';
import formatPrice from '~helpers/currency';
import { TagType } from '~constants/tagType';
import { IconTimerNotice } from '~components/svgs/';

import Tag from './tag';

const CounterOffer = ({
  property,
  t,
  showPerPrice,
  showTotalPrice,
  showTagDesc,
  showReselectNotice,
  tagType,
  descType,
}) => (
  <div
    className={classnames('counter-offer', tagType === TagType.counterOffer && 'counter-offer__bg')}
  >
    <If condition={tagType !== 'default'}>
      <Tag tagType={tagType} t={t} showTagDesc={showTagDesc} descType={descType} />
    </If>
    <div className="counter-offer__container">
      <div>
        <div className="counter-offer__detail">
          <IconPropertyOutline className="preIcon" />
          <span className="counter-offer__normal">{property?.propertyName}</span>
        </div>
        <div className="counter-offer__detail">
          <HomeGrayIcon className="preIcon" />
          <span className="counter-offer__normal">{property?.unitTypeName}</span>
          <span className="category">
            ({t(`landlord.booking.detail.label.${property?.unitTypeCategory?.toLowerCase()}`)})
          </span>
        </div>
        <div className="check-in-out">
          <div className="check-in-out__left">
            <CalendarGrayIcon className="preIcon" />
            <span className="counter-offer__normal">
              {formatDay(dayFormatType.BOOKINGTABLE, property?.moveInDate)}
            </span>
            <ArrowRightIcon className="arrowIcon" />
            <span className="counter-offer__normal">
              {formatDay(dayFormatType.BOOKINGTABLE, property?.moveOutDate)}
            </span>
            <span className="counter-offer__weeks">
              {calcTenancyLength(t, property?.moveInDate, property?.moveOutDate)}
            </span>
          </div>
        </div>
      </div>
      <If condition={showTotalPrice}>
        <div className="total-price__wrapper">
          <div>
            <span className="total-price__label">
              {t('landlord.long_tail.booking_details.label.total_price')}:
            </span>
            <span className="total-price__value">
              {formatPrice(property?.totalPrice, property?.currency)}
            </span>
          </div>
          <If condition={showPerPrice && property?.listingSalesPrice}>
            <div className="total-price__discount">
              <span className="total-price__discount-label">
                {formatPrice(property?.listingSalesPrice, property?.currency, 2)}
              </span>
              <span>
                {t(`landlord.listing.billing_cycle.per_${property?.billingCycle?.toLowerCase()}`)}
              </span>
            </div>
          </If>
        </div>
      </If>
    </div>

    <If condition={showReselectNotice}>
      <p className="counter-offer-reselect__notice">
        <IconTimerNotice />
        <span>{t('landlord.long_tail.booking.counter_confirm_modal.notice')}</span>
      </p>
    </If>
  </div>
);

CounterOffer.propTypes = {
  t: PropTypes.func.isRequired,
  property: {
    unitTypeName: PropTypes.string.isRequired,
    unitTypeCategory: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
    moveInDate: PropTypes.string.isRequired,
    moveOutDate: PropTypes.string.isRequired,
    billingCycle: PropTypes.string,
    listingDiscountValue: PropTypes.string,
  },
  showPerPrice: PropTypes.bool,
  showTotalPrice: PropTypes.bool,
  showTagDesc: PropTypes.bool,
  tagType: PropTypes.string,
  descType: PropTypes.string,
};

CounterOffer.defaultProps = {
  showPerPrice: false,
  showTotalPrice: false,
  tagType: 'default',
  showTagDesc: true,
  descType: '',
};

export default CounterOffer;
